import { render, staticRenderFns } from "./PrescrizioniRipetibili.vue?vue&type=template&id=e36dab02"
import script from "./PrescrizioniRipetibili.vue?vue&type=script&lang=js"
export * from "./PrescrizioniRipetibili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports